/**
 * Drops stale async responses: call `begin()` before starting a request and
 * check the returned function when the response arrives — it is true only if
 * no newer `begin()` (or `cancel()`) has happened since.
 */
export function createLatestRequestGuard() {
  let latest = 0;
  return {
    begin(): () => boolean {
      latest += 1;
      const mine = latest;
      return () => mine === latest;
    },
    /** Invalidates everything in flight (e.g. the query was cleared). */
    cancel(): void {
      latest += 1;
    }
  };
}

/** A trailing-edge debounce with `cancel()`. */
export function createDebouncer(delayMs: number) {
  let timer: ReturnType<typeof setTimeout> | null = null;
  return {
    run(fn: () => void): void {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        fn();
      }, delayMs);
    },
    cancel(): void {
      if (timer) clearTimeout(timer);
      timer = null;
    }
  };
}
